export const XbyYPairs = [
  'AAVE/BNB',
  'AAVE/AVAX',
  'AAVE/APT',
  'AAVE/ADA',
  'AAVE/BTC',
  'ETH/SOL',
  'SOL/ETH',
  'ETH/BTC',
]
